module.exports = __webpack_public_path__ + "img/full6-min.ff2aca70.png";